// Fase 4 · Interruptor del tiempo real V2 (`/hub/tpv`).
//
//   - Build: `REACT_APP_REALTIME_V2` ("false" lo apaga; por defecto activo en
//     esta rama).
//   - Runtime (kill-switch sin redeploy): localStorage `tmo:realtimeV2 = "0"`
//     vuelve a los hubs legacy. Se lee al cargar la página: tras cambiarlo,
//     recargar.
//
// Con V2 activo, los layouts TPV dejan de abrir los hubs legacy que V2
// sustituye (mesas, pedidos, productos, reservas) para no procesar dos veces.

export const REALTIME_V2_STORAGE_KEY = "tmo:realtimeV2";

export function isRealtimeV2Enabled({
  env = process.env.REACT_APP_REALTIME_V2,
  storage = typeof window !== "undefined" ? window.localStorage : undefined,
} = {}) {
  if (String(env ?? "").toLowerCase() === "false") return false;
  try {
    const v = storage?.getItem?.(REALTIME_V2_STORAGE_KEY);
    if (v === "0" || v === "false") return false;
  } catch {
    // localStorage bloqueado: nos quedamos con el valor del build.
  }
  return true;
}

/**
 * Hubs legacy que abre cada layout según el modo. Solo documenta/decide; los
 * layouts montan el componente correspondiente.
 */
export const LEGACY_HUBS_REPLACED_BY_V2 = ["mesahub", "pedidohub", "producthub", "bookinghub"];

export function hubsForLayout(layout, v2Enabled) {
  // Con V2 todo pasa por `/hub/tpv`: los hooks legacy de estos layouts se
  // puentean (src/realtime/legacyBridge.js) sin abrir su socket. Solo la carta
  // QR abre además `startsessionhub` antes de tener token de sesión.
  if (v2Enabled) return layout === "qrPreSession" ? ["startsessionhub"] : ["tpv"];
  const common = {
    tpvCarta: ["userhub", "usersession"],
    dashboard: ["userhub", "usersession", "logs", "workerstatus", "notificationrestaurantehub", "cashdrawer"],
    kds: ["displaykitchenhub"],
    qr: ["sessionhub", "notificationsessionhub", "producthub"],
  }[layout] || [];
  return layout === "kds" || layout === "qr" ? common : [...LEGACY_HUBS_REPLACED_BY_V2, ...common];
}
